import { render, staticRenderFns } from "./report-v6.vue?vue&type=template&id=487f1093&scoped=true"
import script from "./report-v6.vue?vue&type=script&lang=ts"
export * from "./report-v6.vue?vue&type=script&lang=ts"
import style0 from "./report-v6.vue?vue&type=style&index=0&id=487f1093&prod&lang=scss"
import style1 from "./report-v6.vue?vue&type=style&index=1&id=487f1093&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "487f1093",
  null
  
)

export default component.exports